module.exports = __webpack_public_path__ + "static/media/skull-bash.614fe6d9.png";